import { FC, memo } from 'react'
import { IconButton } from '@cargomart/ui'
import IconNotification from 'assets/notification.svg?react'
import IconAccount from 'assets/person-circle.svg?react'
import cn from 'classnames'
import { Logo } from 'components/extend/Logo'
import { MenuDropdown } from 'components/extend/MenuDropdown'
import { useActions, useIsMobile, useNotifications, useRootLink } from 'hooks'
import { ModalNotifications } from 'modules/notification/components/NotificationsModal/ModalNotifications'
import { Dropdown } from 'shared/components/Dropdown'
import * as features from 'utils/feature'

import HeaderNavigation from './HeaderNavigation'
import { HeaderProps } from './types'

import s from './Header.module.less'

const Header: FC<HeaderProps> = (props) => {
  const { isModalNotifications, handleOpenModalNotifications, handleCloseModalNotifications, isTablet } = props
  const { notificationNotViewed } = useNotifications()
  const { openMobileSidebar } = useActions()
  const isMobile = useIsMobile()

  const handleOpen = () => {
    openMobileSidebar()
  }

  const rootLink = useRootLink()

  return (
    <>
      <div className={s.header} data-test-id="header">
        <div className={s.container}>
          <div className={s.burger}>
            <IconButton onClick={handleOpen} size="lg">
              <IconAccount size="nm" />
            </IconButton>
          </div>
          <div className={s.logo}>
            <Logo isNewYear={features.newYearLogo} link={rootLink?.to || ''} type="adaptive" />
            <div className={s.navigationBlock}>
              <HeaderNavigation />
            </div>
          </div>
          <div className={s.rightBlock}>
            <div
              // @ts-ignore
              className={cn(s.notificationButton, { [s.notificationButtonActive]: notificationNotViewed > 0 })}
              onClick={handleOpenModalNotifications}
            >
              <span className={s.counter}>{notificationNotViewed}</span>
              <IconButton onClick={handleOpenModalNotifications} size={isMobile ? 'lg' : undefined}>
                <IconNotification size={isMobile ? 'nm' : 'sm'} />
              </IconButton>
              {/* @ts-ignore */}
            </div>
            {!isTablet && (
              <Dropdown
                isFullscreenInMobile
                // eslint-disable-next-line react/no-unstable-nested-components
                dropdownRender={({ handleClose }) => <MenuDropdown onClose={handleClose} />}
                placement="bottom-end"
              >
                {({ handleToggle, ref }) => (
                  <div ref={ref} className="flex items-center">
                    <IconButton onClick={handleToggle}>
                      <IconAccount size="sm" />
                    </IconButton>
                  </div>
                )}
              </Dropdown>
            )}
          </div>
        </div>
      </div>
      <ModalNotifications handleCloseModal={handleCloseModalNotifications} isShow={isModalNotifications} />
    </>
  )
}

export default memo(Header)
